import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { EnumAppMenu } from '@models/AppMenus';
import { StringUtils } from '@utils/StringUtils';

@Component({
    selector: 'app-household-history',
    templateUrl: './household-history.component.html',
    styleUrls: ['./household-history.component.scss'],
})
export class HouseholdHistoryModalComponent {

    public Title: string = 'Histórico do agregado';

    public Data: any[] = [];

    /** linhas expandidas, por IdMember — único entre agregados */
    private expanded = new Set<string>();

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController,
        private NavController: NavController) {

        this.Title = this.NavParams.get('title') || this.Title;
        this.Data = this.NavParams.get('data') || [];
    }

    /**
     * Perfil da pessoa da linha. Fecha o modal antes de navegar — não faz
     * sentido deixá-lo aberto por cima de outra página.
     * @param ev
     * @param item
     */
    public async OnViewMember(ev: any, item: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        const idUser = item?.IdUser || null;

        if (!idUser) return;

        await this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);

        this.NavController.navigateForward([EnumAppMenu.ConsumersCardView, idUser], { animated: true });
    }

    /**
     * Número de cartão, inteiro e em blocos de 4.
     * @param number
     */
    public CardNumber(number: string): string {

        return number ? StringUtils.FormatToCreditCardNumber(number) : '--';
    }

    public IsExpanded(item: any): boolean {

        return !!item?.IdMember && this.expanded.has(item.IdMember);
    }

    public OnToggle(item: any) {

        const id = item?.IdMember;

        if (!id) return;

        this.expanded.has(id) ? this.expanded.delete(id) : this.expanded.add(id);
    }

    public Close() {

        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }
}
